// extracted by mini-css-extract-plugin
export var close = "style-module--close--941fa";
export var complete = "style-module--complete--38b02";
export var completeText = "style-module--completeText--ea7a5";
export var form = "style-module--form--a83d1";
export var input = "style-module--input--13a87";
export var modal = "style-module--modal--dba66";
export var note = "style-module--note--f61b3";
export var policy = "style-module--policy--dafaf";
export var submit = "style-module--submit--83324";
export var title = "style-module--title--8e8be";